import { render, staticRenderFns } from "./bindPhoneAuthCard.vue?vue&type=template&id=7b56407e&"
import script from "./bindPhoneAuthCard.vue?vue&type=script&lang=js&"
export * from "./bindPhoneAuthCard.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneAuthCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports